export default {
  renewal: {
    cta: "Suivant",
    step_1: {
      category: "Valeur Immobilière",
      title: "Est-ce que vous vivez dans cette propriété? Ou est-ce un investissement?",
      subtitle: "Les prêteurs offrent habituellement un rabais pour les propriétés occupées par leur propriétaire.",
      placeholder_value: "$"
    },
    step_2: {
      category: "Détails à propos de la maison",
      title: "Quelle est le solde actuel sur votre hypothèque?",
      placeholder_postalcode: "Code postal",
      placeholder_province: "Province",
      placeholder_streetaddress: "Adresse de rue",
      placeholder_citytownvillage: "Cité / Ville / Village"
    },
    step_3: {
      category: "Détails personnels",
      title: "Combien avez-vous mis en mise de fonds lors de l’achat de la propriété?",
      placeholder_salutation: "Salutation",
      placeholder_ageinyears: "Âge (en années)",
      placeholder_firstname: "Prénom",
      placeholder_lastname: "Nom de famille",
    },
    step_4: {
      category: "Détails de contact",
      title: "Quels sont vos information de contact?",
      placeholder_telephonenumber: "Numéro de téléphone",
      placeholder_emailaddress: "Adresse électronique"
    },
    step_5: {
      category: "Temps",
      title: "Avez-vous consulter afin d'obtenir une hypothèque à libération conditionnelle?",
      placeholder_name: "Nom complet",
      placeholder_email: "E-mail",
      placeholder_areacode: "Code régional",
      placeholder_number: "No de téléphone",
      cta: "NEXT"
    },
    policy:
      "By continuing, you agree to our <a href='/terms-of-service'>Terms of Service</a> and <a href='/privacy-policy'>Privacy Policy</a>.",
    eligibility: {
      label: "You are eligible to receive up to",
      primaryButtonText: "COMMENT APPLIQUER",
      secondaryButtonText: "Sauvegarder un rapport PDF",
      credentialValueLabel: "Valeur",
      credentialAgeLabel: "Âge",
      credentialLocationLabel: "Location"
    },
    thankYou: {
      title: "Merci",
      description: "Un conseiller sera bientôt en contact avec vous afin de vérifier vos informations et d'estimer le bien de votre maison avec vous.",
      downloadInformationLabel: "TÉLÉCHARGER LES INFORMATIONS"
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/translations/fr/renewal.js